"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActualViewData = getActualViewData;
function getActualViewData(state) {
  if (!state.view.data?.headingType) {
    return null;
  }
  return {
    data: {
      headingType: state.view.data.headingType
    }
  };
}